import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
import S_factoryEffect from "@/service/api/v1/factoryEffect";

export default {
  async index(params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      modelName: 'effect',
      params: _params,
    });
    return res;
  },
  async getEffectList() {
    const factoryId = store.state.app.factory.id
    const params = {
      order_by: "sequence",
      order_way: "asc",
      factory: factoryId,
      get_all: 1,
    };
    const resEffectList = await this.index(params);
    const effectList = resEffectList.map(effect => {
      return {
        ...effect,
        type: 'effects'
      };
    });
    const resFactoryEffectList = await S_factoryEffect.index(params);
    const factoryEffectList = resFactoryEffectList.map(effect => {
      return {
        ...effect,
        type: 'factoryEffects'
      };
    });
    return [...effectList, ...factoryEffectList];
  },
};
